import i18next from '../translations/i18n';

const colors = {
  positive: { r: 56, g: 196, b: 119 },
  neutral: { r: 238, g: 238, b: 238 },
  negative: { r: 242, g: 84, b: 61 },
};

const getAlpha = (pct, percentColors) => {
  const range = 0.3;
  const min = percentColors[0].pct;
  const max = percentColors[2].pct;

  let res = 0;

  if (pct < 0) {
    res = (range * pct) / min;
  } else if (pct > 0) {
    res = (range * pct) / max;
  }

  return 0.8 + res;
};

const getColorForPercentage = (pct, percentColors) => {
  let i = 1;
  for (i; i < percentColors.length - 1; i += 1) {
    if (pct < percentColors[i].pct) {
      break;
    }
  }
  const lower = percentColors[i - 1];
  const upper = percentColors[i];
  const range = upper.pct - lower.pct;
  if (range === 0) {
    return {
      ...colors.neutral,
      a: getAlpha(pct, percentColors),
    };
  }
  const rangePct = (pct - lower.pct) / range;
  const pctLower = 1 - rangePct;
  const pctUpper = rangePct;
  const color = {
    r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
    g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
    b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
    a: getAlpha(pct, percentColors),
  };
  return color;
};

const Utils = {
  formatDate: (dt) => {
    let aux = dt;
    if (typeof aux === 'string') {
      aux = new Date(aux);
    }

    const monthNames = i18next.t('Months');
    const date = `${aux.getDate() < 10 ? `0${aux.getDate()}` : aux.getDate()}`;
    const monthName = `${JSON.parse(monthNames)[aux.getMonth()]}`;
    const fullYear = `${aux.getFullYear()}`;

    return `${date} ${monthName} ${fullYear}`;
  },

  asignColorsToItems: (itemsArr) => {
    const auxArr = itemsArr.map((x) => x.chg);
    const max = Math.max(...auxArr);
    const min = Math.min(...auxArr);
    const percentColors = [
      { pct: min, color: colors.negative },
      { pct: 0, color: colors.neutral },
      { pct: max, color: colors.positive },
    ];
    return itemsArr.map((item) => ({
      ...item,
      color: getColorForPercentage(item.chg, percentColors),
    }));
  },

  getChangedTickers: (oldData, newData) => {
    const arr = [];
    if (oldData.length === 0) {
      return arr;
    }

    oldData.forEach((assetClass) => {
      assetClass.groups.forEach((group) => {
        group.underlyingList.forEach((u) => {
          const newChg = newData
            .find((x) => x.name === assetClass.name)
            .groups.find((x) => x.name === group.name)
            .underlyingList.find((x) => x.name === u.name);

          if (u.chg !== newChg.chg) {
            arr.push(newChg.name);
          }
        });
      });
    });

    return arr;
  },

};

export default Utils;
